import { render, staticRenderFns } from "./EditorHeaderPresentButton.vue?vue&type=template&id=ecab3e92&scoped=true&"
import script from "./EditorHeaderPresentButton.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderPresentButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderPresentButton.vue?vue&type=style&index=0&id=ecab3e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecab3e92",
  null
  
)

export default component.exports